export const CHANGES_SAVED = 'Changes saved';
export const DEMAND_DESCRIPTION_TEXT =
  'Input your data and Zlayt AI will generate the demand letter for you';
export const CASE_DESCRIPTION_TEXT =
  'Create a new case by uploading documents for automatic extraction or filling details manually';
export const CASE_DETAILS_DESCRIPTION_TEXT =
  'Review and correct the case details, add records as they arrive, and create documents for this case';
export const DEPOSITION_SUMMARY_DESCRIPTION_TEXT =
  'Input your data and Zlayt AI will generate the deposition summary for you';
export const FREE_SUBSCRIPTION_NAME = 'ZlaytAI Free';
